import { render, staticRenderFns } from "./Businessmembership.vue?vue&type=template&id=dba1a544&"
import script from "./Businessmembership.vue?vue&type=script&lang=js&"
export * from "./Businessmembership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports